exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".folder[data-v-78388beb]:before {\n  font-family: 'FontAwesome';\n  content: \"\\F07B\";\n  display: inline-block;\n  padding-right: 5px;\n  vertical-align: middle;\n  font-weight: 900;\n  font-size: 30px;\n}\n", ""]);

// exports
